import { render, staticRenderFns } from "./Thing.vue?vue&type=template&id=336d93af&scoped=true&"
import script from "./Thing.vue?vue&type=script&lang=ts&"
export * from "./Thing.vue?vue&type=script&lang=ts&"
import style0 from "./Thing.vue?vue&type=style&index=0&id=336d93af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d93af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336d93af')) {
      api.createRecord('336d93af', component.options)
    } else {
      api.reload('336d93af', component.options)
    }
    module.hot.accept("./Thing.vue?vue&type=template&id=336d93af&scoped=true&", function () {
      api.rerender('336d93af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notif/Thing.vue"
export default component.exports